import React from "react";

class TitleBar extends React.Component {
  render() {
    const sectionStyle = {
      background: "#000",
      padding: "20px"
    };

    const h1Style = {
      color: "#fff"
    };
    return (
      <section className="section" style={sectionStyle}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center section_title">
                <h1
                  className="font-weight-bold wherehome-white"
                  style={h1Style}
                >
                  we're here to maximize your travel experience.
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default TitleBar;



// WEBPACK FOOTER //
// ./src/layout/TitleBar.js